import React from 'react';
import { Col, Row } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

import { CenteredContainer as Container } from '../fields/Container';
import TutorDOwl from '../../assets/tutord-signin-page.svg';
import { BackPage, SignInUpCol, YellowUnderline, Img, BigTitle, WhiteText } from '../../styles/StyledComponents';

import Header from '../template/Header';
import useSignUpPage from './hooks/useSignUpPage';
import { Link } from 'react-router-dom';
import { SignUpForm } from './SignUpForm';

const SignUpPage = () => {
  const { isLoading, formState } = useSignUpPage();

  console.log('formState:', formState);
  return (
    <Container style={{ width: '100%' }}>
      <Row justify='center'>
        <Col xl={10} xs={24} style={{ paddingBottom: 30 }}>
          <Header />
          <div style={{ padding: '0px 24px', textAlign: 'center' }}>
            <BigTitle>TutorD</BigTitle>
            <Img src={TutorDOwl} alt='TutorD Owl' />
            <WhiteText>
              <FormattedMessage id='sign-up.aside.subTitle' />
            </WhiteText>
            <WhiteText style={{ fontSize: '1.5em' }}>
              <FormattedMessage id='sign-up.aside.description' />
            </WhiteText>
            <Link to='/'>
              <BackPage>
                <ArrowLeftOutlined style={{ marginRight: 5 }} />
                <FormattedMessage id='shared-button.back-link' />
              </BackPage>
            </Link>
          </div>
        </Col>
        <SignInUpCol xl={14} xs={24}>
          <YellowUnderline level={3}>
            <FormattedMessage id='sign-up.aside.subTitle' />
          </YellowUnderline>
          <SignUpForm
            isLoading={isLoading}
            initialValues={{
              uid: formState.uid || '',
              email: formState.email || '',
              orgId: formState.orgId || '',
              orgName: formState.orgName || ''
            }}
          />
        </SignInUpCol>
      </Row>
    </Container>
  );
};

export default SignUpPage;
